<template>
  <div v-if="init" :class="$setClasses">
    <nxt-core-input-label :class="$vClass('label')"
                          :text="field?.title || $t('rooms.rooms.label')"/>
    <div :class="$vClass('list')">
      <nxt-core-room v-for="(room, index) in rooms"
                     :key="index"
                     v-model:nb="room.nb"
                     :room="room"
                     :room-name="room.name"
                     @update:nb="(nb)=>{updateRoom(room, nb)}"
      />
    </div>
    <div :class="$vClass('new')">
      <el-input
        v-model="newRoom"
        :placeholder="$t('rooms.newRoom.placeholder')">
      </el-input>
      <el-button :class="$vClass('new__button')"
                 :disabled="newRoom.length === 0"
                 @click="addRoom">
        {{ $t('rooms.newRoom.add') }}
      </el-button>
    </div>
    <nxt-core-modal v-model:visible="displaySuppressCard"
                    height="fit-content"
                    width="300px">
      <div>
        <font-awesome-icon :class="$vClass('warning-deletion__icon')"
                           :icon="['fal', 'exclamation-triangle']"/>
        <div :class="$vClass('warning-deletion__content')">
          {{ $t('inventory.deletionOnNextPage') }}
        </div>
      </div>
    </nxt-core-modal>
  </div>
  <nxt-core-loader v-else
                   :text="$t('base.loading')"
                   sizeLoader="--size-small"/>
</template>

<script>
import Input from '@nextories/vue-core-components/src/components/atoms/input/NxtCoreInput.vue';
import { mapState, mapActions } from 'pinia';
import { useFurnituresStore } from '@nextories/vue-core-components/src/store/furnituresStore.ts';

export default {
  nameClassStyle: 'room',
  extends: Input,
  name: 'Rooms',
  data() {
    return {
      newRoom: '',
      rooms: [],
      init: false,
    };
  },
  computed: {
    ...mapState(useFurnituresStore, {
      customRoom: 'customRoom',
      userRooms: 'rooms',
      displayCannotSuppressCard: 'displayCannotSuppressCard',
    }),
    displaySuppressCard: {
      get() {
        return this.displayCannotSuppressCard;
      },
      set(value) {
        this.setDisplayCannotSupressCard(value);
      },
    },
    preDefinedRooms() {
      function compare(room1, room2) {
        if (room1.name > room2.name) return 1;
        if (room2.name > room1.name) return -1;
        return 0;
      }
      return [...useFurnituresStore().preDefinedRooms].sort(compare);
    },
  },
  methods: {
    ...mapActions(useFurnituresStore, [
      'getPreDefinedRooms',
      'setDisplayCannotSupressCard',
      'setRoom',
    ]),
    addRoom() {
      const room = {
        name: this.newRoom,
        piece_type: this.customRoom,
        nb: 1,
      };
      this.rooms.push(room);
      this.updateRoom(room);
      this.newRoom = '';
    },
    updateRoom(room, nb) {
      if (room.nb - 1 === nb) room.nb = nb;
      this.setRoom(room);
      this.model = this.userRooms;
    },
    addCustomRoomToRooms() {
      const customRoomNumberByName = {};
      const customRooms = this.userRooms.filter((r) => r.piece_type === this.customRoom);
      for (let i = 0; i < customRooms.length; i += 1) {
        if (customRoomNumberByName[customRooms[i].name]) {
          customRoomNumberByName[customRooms[i].name] += 1;
        } else {
          customRoomNumberByName[customRooms[i].name] = 1;
        }
      }
      const customName = Object.keys(customRoomNumberByName);
      customName.sort();
      for (let i = 0; i < customName.length; i += 1) {
        this.rooms.push({
          name: customName[i],
          value: this.customRoom,
          nb: customRoomNumberByName[customName[i]],
        });
      }
    },
    addStandardRoomsToRooms() {
      const roomTypes = {};
      const standardUserRooms = this.userRooms.filter((r) => r.piece_type !== this.customRoom);

      for (let i = 0; i < standardUserRooms.length; i += 1) {
        if (roomTypes[standardUserRooms[i].piece_type]
          && standardUserRooms[i].piece_type) {
          roomTypes[standardUserRooms[i].piece_type] += 1;
        } else if (standardUserRooms[i].piece_type) {
          roomTypes[standardUserRooms[i].piece_type] = 1;
        }
      }

      this.rooms.push(...this.preDefinedRooms
        .map((room) => ({
          ...room,
          nb: roomTypes[room.value] ? roomTypes[room.value] : 0,
        })));

      this.rooms.sort((r1, r2) => r1.name > r2.name);
    },
    initRooms() {
      this.addStandardRoomsToRooms();
      this.addCustomRoomToRooms();
    },
  },
  async created() {
    try {
      if (this.preDefinedRooms.length === 0) {
        await this.getPreDefinedRooms()
          .then(() => {
            this.initRooms();
          })
          .finally(() => {
            this.init = true;
          });
      } else {
        this.initRooms();
        this.init = true;
      }
    } catch (error) {
    }
  },
};
</script>

<style lang="scss" scoped>
.#{$prefixName}room {

  &__list {
    display: flex;
    flex-direction: column;
    padding: 0;
    @include breakpoint(desktop) {
      width: 100%;
      padding: .8em;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 2px 30px;
    }
  }

  &__new {
    width: 100%;
    max-width: 400px;
    display: grid;
    grid-template-columns: minmax(100px, 1fr) 100px;

    @include breakpoint(desktop) {
      padding: .8em;
    }

    &__button {
      background: var(--nxt-color-secondary);
      color: white;
      margin: 0 5px;
    }

    :deep(.el-input__inner) {
      border: 0;
    }
  }

  .#{$prefixName}warning-deletion {
    &__icon {
      width: 42px;
      height: 42px;
      margin: 0 auto 20px auto;
      display: block;
    }

    &__content {
      text-align: center;
    }
  }
}

</style>
